export default __webpack_public_path__ + "static/media/fr.7d54188f.svg";